import type {
  AppPageStickyOptions,
  PricingPlansSectionOptions,
} from '@wix/app-market-components';
import type {
  AppModalDisplayOptions,
  AppPageType,
} from '@wix/app-market-core-components-types';

export interface AppPageOptions extends AppModalDisplayOptions {
  showRecommendedForYou?: boolean;
  showHeaderLinks?: boolean;
  stickyHeaderOptions?: AppPageStickyOptions;
  pricingOptions?: PricingPlansSectionOptions;
  mode?: 'test' | 'unlisted';
  showFeaturedIn?: boolean;
  disabledLinks?: AppPageLink[];
  appPageType?: AppPageType;
  showAppPageLink?: boolean;
}

export enum AppPageLink {
  'COMPANY_PAGE' = 'COMPANY_PAGE',
}

export interface AppFetchOptions {
  fetchPermissions?: boolean;
  fetchManagedApps?: boolean;
}
